import moment from 'moment';
import DTO from './DTO';

class HostStatusDetailDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'host',
        type: String,
        validators: [],
        labelKey: 'host',
      },
      {
        name: 'zbx_address',
        type: String,
        validators: [],
        labelKey: 'zbx_address',
      },
      {
        name: 'message',
        type: String,
        validators: [],
        labelKey: 'message',
      },
      {
        name: 'status',
        type: String,
        validators: [],
        labelKey: 'status',
      },
      {
        name: 'from',
        type: moment,
        validators: [],
        labelKey: 'from',
      },
      {
        name: 'to',
        type: moment,
        validators: [],
        labelKey: 'to',
      },
    ];
    super(attributes, params, isValidInit);
  }
}

export default HostStatusDetailDTO;
